import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Box, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";

import { FiFacebook, FiInstagram, FiLinkedin } from "../assets/icons/vander";
import { fetchCollaborator } from "../redux/actions/collaboratorAction";
import { useAppDispatch } from "../redux/hook";
import Pagination from "../utils/Pagination";

export default function TeamDetail({ pagination = true }) {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  // Pagination start
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [total, setTotal] = useState(0);
  const [limit, setLimit] = useState(4);
  // Pagination end

  const [collaborators, setCollaborators] = useState([]);
  const [loading, setLoading] = useState(true);

  const loadCollaborators = async () => {
    const data = {
      page: page,
      limit: limit,
    };

    const collaborator = await dispatch(fetchCollaborator(data));

    if (
      typeof collaborator.payload === "string" ||
      collaborator.payload === undefined
    ) {
      setLoading(false);
    } else {
      setCollaborators(collaborator.payload.collaborator);
      setTotalPages(collaborator.payload.totalPages);
      setTotal(collaborator.payload.total);
      setPage(collaborator.payload.page);
      setLimit(collaborator.payload.limit);
    }
    setLoading(false);
  };

  useEffect(() => {
    loadCollaborators(page, limit);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, limit]);

  if (loading) {
    return (
      <Box
        sx={{
          justifyContent: "center",
          alignItems: "center",
          display: "flex",
          top: "50%",
        }}
      >
        <CircularProgress />
      </Box>
    );
  }

  return (
    <>
      <div className="container relative lg:mt-24 mt-16">
        <div className="grid grid-cols-1 pb-6 text-center">
          <h3 className="mb-4 md:text-2xl text-xl font-medium">
            {t("external.team.our_team")}
          </h3>

          <p className="text-slate-400 dark:text-white/60 max-w-xl mx-auto">
            {t("external.team.here_there_are_some_of_our_collaborators")}
          </p>
        </div>
        <div className="grid md:grid-cols-12 grid-cols-1 mt-6 gap-6">
          {pagination
            ? collaborators.map((item, index) => {
                return (
                  <div className="lg:col-span-3 md:col-span-6" key={index}>
                    <div className="group text-center">
                      <div className="relative inline-block mx-auto h-52 w-52 rounded-full overflow-hidden">
                        <img
                          src={
                            process.env.REACT_APP_API_URL +
                            "/wwwroot/images/" +
                            item.image_file
                          }
                          className=""
                          alt=""
                        />

                        <ul className="list-none absolute top-1/2 -translate-y-1/2 -end-20 group-hover:end-5 transition-all duration-500 ease-in-out">
                          <li className="">
                            <Link
                              to=""
                              className="h-8 w-8 inline-flex items-center text-center justify-center text-base font-normal tracking-wide border align-middle transition duration-500 ease-in-out rounded-full bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white"
                            >
                              <FiFacebook className="h-4 w-4" />
                            </Link>
                          </li>
                          <li className="mt-1">
                            <Link
                              to=""
                              className="h-8 w-8 inline-flex items-center text-center justify-center text-base font-normal tracking-wide border align-middle transition duration-500 ease-in-out rounded-full bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white"
                            >
                              <FiInstagram className="h-4 w-4" />
                            </Link>
                          </li>
                          <li className="mt-1">
                            <Link
                              to=""
                              className="h-8 w-8 inline-flex items-center text-center justify-center text-base font-normal tracking-wide border align-middle transition duration-500 ease-in-out rounded-full bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white"
                            >
                              <FiLinkedin className="h-4 w-4" />
                            </Link>
                          </li>
                        </ul>
                      </div>

                      <div className="content mt-3">
                        <Link
                          to={`/collaborator`}
                          className="text-lg font-medium hover:text-orange-500 duration-500"
                        >
                          {item.name}
                        </Link>
                        <p className="text-slate-400 dark:text-white/60">
                          {item.position}
                        </p>
                        <p className="text-slate-400 dark:text-white/60">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })
            : collaborators.slice(0, 4).map((item, index) => {
                return (
                  <div className="lg:col-span-3 md:col-span-6" key={index}>
                    <div className="group text-center">
                      <div className="relative inline-block mx-auto h-52 w-52 rounded-full overflow-hidden">
                        <img
                          src={
                            process.env.REACT_APP_API_URL +
                            "/wwwroot/images/" +
                            item.image_file
                          }
                          className=""
                          alt=""
                        />

                        <ul className="list-none absolute top-1/2 -translate-y-1/2 -end-20 group-hover:end-5 transition-all duration-500 ease-in-out">
                          <li className="">
                            <Link
                              to=""
                              className="h-8 w-8 inline-flex items-center text-center justify-center text-base font-normal tracking-wide border align-middle transition duration-500 ease-in-out rounded-full bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white"
                            >
                              <FiFacebook className="h-4 w-4" />
                            </Link>
                          </li>
                          <li className="mt-1">
                            <Link
                              to=""
                              className="h-8 w-8 inline-flex items-center text-center justify-center text-base font-normal tracking-wide border align-middle transition duration-500 ease-in-out rounded-full bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white"
                            >
                              <FiInstagram className="h-4 w-4" />
                            </Link>
                          </li>
                          <li className="mt-1">
                            <Link
                              to=""
                              className="h-8 w-8 inline-flex items-center text-center justify-center text-base font-normal tracking-wide border align-middle transition duration-500 ease-in-out rounded-full bg-orange-500 hover:bg-orange-600 border-orange-500 hover:border-orange-600 text-white"
                            >
                              <FiLinkedin className="h-4 w-4" />
                            </Link>
                          </li>
                        </ul>
                      </div>

                      <div className="content mt-3">
                        <Link
                          to={`/collaborator`}
                          className="text-lg font-medium hover:text-orange-500 duration-500"
                        >
                          {item.name}
                        </Link>
                        <p className="text-slate-400 dark:text-white/60">
                          {item.position}
                        </p>
                        <p className="text-slate-400 dark:text-white/60">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                );
              })}
        </div>

        {pagination && (
          <Pagination
            page={page}
            setPage={setPage}
            totalPages={totalPages}
            limit={limit}
            setLimit={setLimit}
            total={total}
            firstOption={4}
          />
        )}
      </div>
    </>
  );
}
